import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import moment from "moment";
import { Grid} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import {
  AccessTime as Watch,
  DateRange,
  Close,
  ColorLensOutlined,
  Label,
} from "@material-ui/icons";
import { makeStyles,useTheme } from "@material-ui/core/styles";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import ClockedIn2 from "./Cards/ClockedIn2";
import EmployeesActivities from "./Cards/EmployeesActivities";
import ActivityHoursPlanned from "./Cards/ActivityHoursPlanned";
import LoaderView from "components/LoaderView";
import CardLayout from "pages/Dashboard2.1/components/CardLayout";
import ActivityByJobRole from "./ActivityByJobRole";
import Menu from "@material-ui/core/Menu";
import Paper from "@material-ui/core/Paper";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import Select from "@material-ui/core/Select";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Checkbox,
  TextField,
  Button,
  FormLabel,
  Typography,
  Popper
} from "@material-ui/core";

import Autocomplete from "@material-ui/lab/Autocomplete";
// Router
import { useHistory } from "react-router-dom";

import {
  getManagerEmails,
  selectedManagerForApproval,
  selectedWorkerOnReview,
  selectedWeekOnReview,
  selectedMonthOnReport,
  selectedTeamOnReview,
  getCountries,
  saveDashboardDistrictsData,
  saveDashboardBuildingsData,
  saveDashboardManagerData,
  saveDashboardDistrictForAph
} from "redux/actions/appActions";
import {
  getClockedInReport,
  getActivityGroupReportData,
  getActivitesByJobFamilyReport,
  getJobFamilyReportData,
  getWorkersListByMgr,
  getActivityHoursReportData,
  getDashboardCollection,
  getDscDashboardCollection,
  getCapacityPlanningCollection,
  getSelectedBuildingTargetAph
} from "utils/report";
import { WARE_HOUSE_TIMELINE_VIEW } from "navigation/CONSTANTS";
import { MY_TEAM, MANAGE_FOR_BY_COUNTRY } from "config/CONSTANTS";
import {acivityIds, activitiesInOrder} from "config";
import { getStartOfWeek, getEndOfWeek, properCase, isEmptyObject } from "utils";
import {
  getDistrictBuildingMapForIMWarehouse,
  getParentManager,
  getWeekNumber,
  getWeekStartDate,
} from "services";
import { getWorkerIMTimeRole } from "services/workerSchedule";
import {
  getTranslatedActivityGroupFromCamelCase,
  convertCamelToNormalCase,
} from "./components/utils";
import { getFullName } from "utils";
import ActivityHoursByEmployee from "./Cards/ActivityHoursByEmployee";
import { VariableSizeList } from 'react-window';
import PropTypes from 'prop-types';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import ListSubheader from '@material-ui/core/ListSubheader';
import StopIcon from '@material-ui/icons/Stop';

import WorkerLogin from "./components/WorkerLogin"
import {analytics} from 'services/firebase';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  listbox: {
    boxSizing: 'border-box',
    '& ul': {
      padding: 0,
      margin: 0,
    },
  },
  listSubHeader:{
    cursor:'pointer',
    "&:hover": {
      backgroundColor: '#F6F6F6'
    },
    top:0,
    color:'#000000de'
  }
}));

const LISTBOX_PADDING = 8; // px

function renderRow(props) {
  const { data, index, style } = props;
  return React.cloneElement(data[index], {
    style: {
      ...style,
      //top: style.top + LISTBOX_PADDING,
    },
  });
}

const OuterElementContext = React.createContext({});

const OuterElementType = React.forwardRef((props, ref) => {
  const outerProps = React.useContext(OuterElementContext);
  return <div ref={ref} {...props} {...outerProps} />;
});

function useResetCache(data) {
  const ref = React.useRef(null);
  React.useEffect(() => {
    if (ref.current != null) {
      ref.current.resetAfterIndex(0, true);
    }
  }, [data]);
  return ref;
}

// Adapter for react-window
const ListboxComponent = React.forwardRef(function ListboxComponent(props, ref) {
  const { children, ...other } = props;
  const itemData = React.Children.toArray(children);
  const theme = useTheme();
  const smUp = useMediaQuery(theme.breakpoints.up('sm'), { noSsr: true });
  const itemCount = itemData.length;
  const itemSize = smUp ? 36 : 48;

  const getChildSize = (child) => {
    if (React.isValidElement(child) && child.type === ListSubheader) {
      return 48;
    }

    return itemSize;
  };

  const getHeight = () => {
    if (itemCount > 8) {
      return 8 * itemSize;
    }
    return itemData.map(getChildSize).reduce((a, b) => a + b, 0);
  };

  const gridRef = useResetCache(itemCount);

  return (
    <div ref={ref}>
      <OuterElementContext.Provider value={other}>
        <VariableSizeList
          itemData={itemData}
          height={getHeight() + 2 * LISTBOX_PADDING}
          width="100%"
          ref={gridRef}
          outerElementType={OuterElementType}
          innerElementType="ul"
          itemSize={(index) => getChildSize(itemData[index])}
          overscanCount={5}
          itemCount={itemCount}
        >
          {renderRow}
        </VariableSizeList>
      </OuterElementContext.Provider>
    </div>
  );
});

export const HomeView = () => {
  // const viewOptions =['Daily','Weekly'];
  const history = useHistory();
  const [clockedInReportData, setClockedInReportData] = useState({});
  const [clockedInReportDataLoading, setClockedInReportDataLoading] =
    useState(true);
    const [loading, setLoading] = useState(false);
  const [employeesUnderManager, setEmployeesUnderManager] = useState(null);
  const [employeesUnderManagerLoading, setEmployeesUnderManagerLoading] =
    useState(true);
  const [activityStartDate, setActivityStartDate] = useState(new Date());
  const [currentDate, setCcurrentDate] = useState(moment().format('DD/MM/YYYY'));
  const [jobFamilyChart, setJobFamilyChart] = useState([]);
  const [jobFamilyChartLoading, setJobFamilyChartLoading] = useState(true);
  const [isViewDisabled, SetIsViewDisabled] = useState(true);
  const [StartDateError, SetStartDateError] = useState(false);
  const [chart, setChart] = useState([]);
  const [chartLoading, setChartLoading] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const [timeLineAnchorEl, setTimeLineAnchorEl] = useState(null);
  const [checked, setChecked] = useState([]);
  const [plannedActivityHoursData, setPlannedActivityHoursData] = useState([]);
  const [employeeActivityHoursData, setEmployeeActivityHoursData] = useState({
    employeeHoursData: {},
    employeeHoursTotalData: {},
  });
  const [activityHoursDataLoading, setActivityHoursDataLoading] =
    useState(true);
  const [districtBuildingMap, setDistrictBuildingMap] = useState({});
  const [districtBuildingMapLoading, setDistrictBuildingMapLoading] =
    useState(true);
  const { dashboardDistricts, dashboardAphDistrict } = useSelector((state) => state.appConfig);
  const [selectedDistrictList, setSelectedDistrictList] =
    useState(dashboardDistricts);
    const [selectedAphDistrict, setSelectedAphDistrict] =
    useState(dashboardAphDistrict);  
  const [districtDropdownOpen, setDistrictDropdownOpen] = useState(false);
  const [buildingOptions, setBuildingOptions] = useState([]);
  const { dashboardBuildings,dashboardManager } = useSelector((state) => state.appConfig);
  const [selectedBuilding, setSelectedBuilding] = useState(dashboardBuildings);
  const [buildingDropdownOpen, setBuildingDropdownOpen] = useState(false);
  const [managerOptions, setManagerOptions] = useState([]);
  const [selectedManager, setSelectedManager] = useState(dashboardManager);
  const [newOptions, setNewOptions] = useState([]);
  const [imtRole, setImtRole] = useState("");
  const [loggedinPlusDelegate, setLoggedinPlusDelegate] = useState([]);
  const [allApprovers, setAllApprovers] = useState([]);
  const [prevSelectedManager,setPrevSelectedManager] = useState({});
  const [target,setTarget] = useState([]);
  const [mealEndLoader,setMealEndLoader] = useState(false);

  let viewType = "Daily";
  const classes = useStyles();
  const { t } = useTranslation();
  const { isAuthenticated, user } = useSelector((state) => state.user.auth);

  const dispatch = useDispatch();
  const appConfig = useSelector((state) => state.appConfig);
  const options = [
    // { name: "Leaves", key: 0 },
    { name: "Meals", key: 1 },
  ];
  const TimeLineoptions = [{ name: "Time Line View", key: 1 }];

  useEffect(() => {
    if (user.workerId && appConfig && appConfig.managerEmails !== null) {
      getWorkerIMTimeRole(user.workerId).then((data) => {
        setImtRole(data.role);
      });
      getParentManager(user.workerId).then((querySnapshot) => {
        let optionsAvailable = appConfig.managerEmails.filter(
          (elem) =>
            querySnapshot.findIndex(
              (obj) => obj.managerId === elem.managerId
            ) >=0
        );
        setNewOptions(optionsAvailable);
      });
    }
  }, [user, appConfig.managerEmails]);

  useEffect(() => {
    if (user) {
      let loggedinCountryManagers = managerOptions.filter(
        (item) => item.managerCountry === user.country
      );

      let totalManagers = [...loggedinCountryManagers, ...newOptions];

      const userManagerObject = {
        managerCountry: user.country,
        managerEmail: user.email,
        managerFirstName: user.firstName,
        managerId: user.workerId,
        managerLastName: user.lastName,
      };

      totalManagers.push(userManagerObject);

      let removeRepeated = totalManagers.filter(
        (elem, index) =>
          totalManagers.findIndex((obj) => obj.managerId === elem.managerId) ===
          index
      );

      setLoggedinPlusDelegate(removeRepeated);
      setAllApprovers(managerOptions);
    }
  }, [newOptions]);

  useEffect(() => {
    if (appConfig && appConfig.managerEmails !== null) {
      let managerDetails = appConfig.managerEmails;
      managerDetails = managerDetails.filter(
        (record) => record.managerId !== user.workerId
      );
      setManagerOptions(managerDetails);
    }
  }, [user, appConfig.managerEmails]);

  useEffect(() => {
    console.log("user.workerId", user,dashboardManager);
    if(user){
      analytics.logEvent('imtime_eopslog_page_visited',{
        userId:user?user.workerId:"",
        userName:user.firstName+" "+user.lastName,
        userCountry:user.country?user.country:""
      })
    if(Object.keys(dashboardManager).length>0){
      setDistrictBuildingMapLoading(true);
      getDistrictBuildingMapForIMWarehouse(dashboardManager.managerCountry)
        .then((data) => {
          setDistrictBuildingMap(data);
          setDistrictBuildingMapLoading(false);
          setActivityHoursDataLoading(false);
        })
        .catch((error) => {
          setDistrictBuildingMapLoading(false);
          console.log("getDistrictBuildingMapForIMWarehouse err ", error);
        });
      setSelectedManager(dashboardManager);
      setPrevSelectedManager(dashboardManager);
      if(selectedBuilding.length>0){
        handleView(dashboardManager);
      }
    }else{
      setDistrictBuildingMapLoading(true);
      getDistrictBuildingMapForIMWarehouse(user.country)
        .then((data) => {
          setDistrictBuildingMap(data);
          setDistrictBuildingMapLoading(false);
          setActivityHoursDataLoading(false);
        })
        .catch((error) => {
          setDistrictBuildingMapLoading(false);
          console.log("getDistrictBuildingMapForIMWarehouse err ", error);
        });

      const userManagerObject = {
        managerCountry: user.country,
        managerEmail: user.email,
        managerFirstName: user.firstName,
        managerId: user.workerId,
        managerLastName: user.lastName,
      };
      
      setSelectedManager(userManagerObject);
      setPrevSelectedManager(userManagerObject);
    }

      if (appConfig !== null) {
        dispatch(getManagerEmails());
        dispatch(getCountries());
        dispatch(selectedManagerForApproval(null));
        dispatch(selectedWorkerOnReview({}));
        dispatch(selectedWeekOnReview(null));
        dispatch(selectedMonthOnReport(null));
        dispatch(selectedTeamOnReview({ team: MY_TEAM }));
      }
  }
  }, [user]);

  useEffect(() => {
    var startDate = moment().startOf("week").format("YYYY-MM-DD");
    var endDate = moment().endOf("week").format("YYYY-MM-DD");

    if (selectedManager.managerId) {
      setChartLoading(true);
      setClockedInReportDataLoading(true);
      setEmployeesUnderManagerLoading(true);
      setJobFamilyChartLoading(true);

      const weekNumber = getWeekNumber(new Date());

      getDashboardCollection(selectedManager.managerId, weekNumber)
        .then((data) => {
          let clockedInData = {};
          let chartData = [];
          let jobRoleChartData = [];
          if (!isEmptyObject(data)) {
            // Clocked In card data
            clockedInData = data.clockedInCard;

            // Pie Chart data
            const activityGroupTotals = data.activityGroupTotals;
            Object.keys(activityGroupTotals).map((activityGroup) => {
              // Remove this condition later for meal and leave checkbox
              if (activityGroup !== "meal" && activityGroup !== "leave") {
                chartData.push({
                  name: getTranslatedActivityGroupFromCamelCase(activityGroup),
                  value: activityGroupTotals[activityGroup],
                });
              }
            });

            // Job Role Bar Chart data
            const jobRoleTotals = data.jobRoleTotals;
            Object.keys(jobRoleTotals).map((jobRole) => {
              const activityGroupHours = jobRoleTotals[jobRole];
              // Remove this deletion later for meal and leave checkbox
              delete activityGroupHours.leave;
              delete activityGroupHours.meal;
              const activityGroupHoursObject = {};
              let totalactivityGroupHours = 0;
              if (!isEmptyObject(activityGroupHours)) {
                Object.keys(activityGroupHours).map((activityGroup) => {
                  activityGroupHoursObject[
                    getTranslatedActivityGroupFromCamelCase(activityGroup)
                  ] = activityGroupHours[activityGroup];
                  totalactivityGroupHours += activityGroupHours[activityGroup];
                });

                jobRoleChartData.push({
                  Name: convertCamelToNormalCase(jobRole),
                  Total: totalactivityGroupHours,
                  ...activityGroupHoursObject,
                });
              }
            });
          }
          setClockedInReportData(clockedInData);
          setClockedInReportDataLoading(false);

          setChart(chartData);
          setChartLoading(false);

          setJobFamilyChart(jobRoleChartData);
          setJobFamilyChartLoading(false);
        })
        .catch((error) => {
          setClockedInReportDataLoading(false);
          setChartLoading(false);
          setJobFamilyChartLoading(false);
        });

      getWorkersListByMgr(selectedManager.managerId)
        .then((data) => {
          console.log("getWorkersListByMgr data: ", data);
          setEmployeesUnderManager(data);
          setEmployeesUnderManagerLoading(false);
        })
        .catch((error) => {
          setEmployeesUnderManagerLoading(false);
          console.log("getWorkersListByMgr err ", error);
        });
        // get district options based on selected manager country
    }
  }, [selectedManager]);

  const handleView = async (managerDetails) => {

    console.log("selectedManager",managerDetails)

    analytics.logEvent('imtime_eopslog_data_viewed',{
      userId:user?user.workerId:"",
      userName:user.firstName+" "+user.lastName,
      userCountry:user.country?user.country:"",
      districtSelected:selectedDistrictList
    })
    
    var weekStartDate = getWeekStartDate(new Date());
   
    const weekNumber = getWeekNumber(new Date());
    setActivityHoursDataLoading(true);
    SetIsViewDisabled(true);
    setPlannedActivityHoursData({});
    setTarget({});
    setEmployeeActivityHoursData({
      employeeHoursData: {},
      employeeHoursTotalData: {},
    });
      dispatch(saveDashboardDistrictsData(selectedDistrictList));
      dispatch(saveDashboardBuildingsData(selectedBuilding));
      dispatch(saveDashboardDistrictForAph(selectedAphDistrict));
      if(managerDetails && Object.keys(managerDetails).length>0){
        dispatch(saveDashboardManagerData(managerDetails));
      }else{
        dispatch(saveDashboardManagerData(selectedManager));
      }
      
      
    if (selectedBuilding.length >= 1) {
      const plannedHoursData = [];
      const employeeHoursData = {};
      const employeeHoursTotalData = {};
      const activityTotMap = {};
      const employeeActTotalMap = {};
      const activityNames = [];
      let actsTargetAph = {};
      if(selectedBuilding.length == 1){
        if(selectedAphDistrict && selectedAphDistrict.length > 0 ){
            await getSelectedBuildingTargetAph(selectedAphDistrict[0], selectedBuilding)
                    .then((result) =>{
                      console.log("targetAPH", result);
                      if(result.length >0){
                        actsTargetAph = result[0].activities ? result[0].activities : {};
                      }
                      console.log("targetAPH", actsTargetAph);
                    }).catch(err =>{
                      console.log("err in fetching target APH", err)
                    })
        }
      }
     await getDscDashboardCollection(weekNumber, selectedBuilding)
        .then((result) => {
          // Activity Hours planned
          result.forEach((data) => {
            console.log("result", result)
            let activitiesData;
            const dayTotals = data.actDayTotals;
            if (viewType === "Daily") {
              const selectedDay = moment().format("dddd");
              if (dayTotals[selectedDay]) {
                activitiesData = dayTotals[selectedDay];
              } else activitiesData = {};
            }
            Object.keys(activitiesData).forEach((activity) => {
              const activityName = convertCamelToNormalCase(activity);
              activityNames.push(activityName);
              if (activityTotMap[activityName]) {
                const activityDataMap = { ...activityTotMap[activityName] };
                activityDataMap["actualDuration"] +=
                  activitiesData[activity].actualDuration;
                // activityDataMap["actualAph"] +=
                //   activitiesData[activity].actualAph;
                activityDataMap["actualAssetCount"] +=
                  activitiesData[activity].actualAssetCount;
                activityTotMap[activityName] = activityDataMap;

              } else {
                const actDetailMap = {};
                actDetailMap["actualDuration"] =
                  activitiesData[activity].actualDuration;
                // actDetailMap["actualAph"] = activitiesData[activity].actualAph;
                actDetailMap["actualAssetCount"] =
                  activitiesData[activity].actualAssetCount;
                actDetailMap.translatedKey=activity
                activityTotMap[activityName] = actDetailMap;

              }

              Object.keys(activitiesData[activity]).forEach((employee) => {
                if (
                  employee !== "actualDuration" &&
                  employee != "actualAssetCount" &&
                  employee !== "actualAph"
                ) {
                  const employeeId =
                    activitiesData[activity][employee].workerName;
                  const activityName = convertCamelToNormalCase(activity);
                  const employeeNameId = `${activitiesData[activity][employee].workerName} (${employee})`;
                  if (employeeActTotalMap[activityName]) {
                    const empActTotals = {
                      ...employeeActTotalMap[activityName],
                    };
                    if (empActTotals[employeeId]) {
                      const empDataMap = { ...empActTotals[employeeId] };
                      empDataMap["duration"] +=
                        activitiesData[activity][employee].duration;
                      // empDataMap["aph"] +=
                      //   activitiesData[activity][employee].aph;
                      empDataMap["assetCount"] +=
                        activitiesData[activity][employee].assetCount;
                      empActTotals[employeeId] = empDataMap;
                      employeeActTotalMap[activityName] = empActTotals;
                    } else {
                      const empDataMap = {};
                      empDataMap["duration"] =
                        activitiesData[activity][employee].duration;
                      // empDataMap["aph"] =
                      //   activitiesData[activity][employee].aph;
                      empDataMap["assetCount"] =
                        activitiesData[activity][employee].assetCount;
                      empDataMap["employeeNameId"] = employeeNameId;
                      empActTotals[employeeId] = empDataMap;
                      employeeActTotalMap[activityName] = empActTotals;
                    }
                  } else {
                    const empData = {};
                    const employeeTotalMap = {};
                    // empData["aph"] = activitiesData[activity][employee].aph;
                    empData["assetCount"] =
                      activitiesData[activity][employee].assetCount;
                    empData["duration"] =
                      activitiesData[activity][employee].duration;
                    empData["employeeNameId"] = employeeNameId;
                    employeeTotalMap[employeeId] = empData;
                    employeeActTotalMap[activityName] = employeeTotalMap;
                  }
                }
              });
            });
          });

          // console.log(
          //   "AAAAAAA activityTotMap ",
          //   activityTotMap,
          //   "employeeActTotalMap ",
          //   employeeActTotalMap
          // );

          Object.keys(activityTotMap).forEach((activityName) => {
            const aph =
              activityTotMap[activityName].actualAssetCount /
              activityTotMap[activityName].actualDuration;
              let actId;
               Object.keys(acivityIds).forEach(actName => {
                if(convertCamelToNormalCase(actName) == activityName){
                  actId = acivityIds[actName];
                }     
              });
                const targetAph = actId && actsTargetAph[actId] && actsTargetAph[actId].capacity? actsTargetAph[actId].capacity:0;
            plannedHoursData.push({
              activityName: activityName,
              activityHours: activityTotMap[activityName].actualDuration,
              assetCount: activityTotMap[activityName].actualAssetCount,
              aph: aph.toFixed(2),
              targetCount:0,
              targetAph:(parseFloat(targetAph)).toFixed(2),
              translatedKey:activityTotMap[activityName].translatedKey,
              x: activityTotMap[activityName].translatedKey,
              y: activityTotMap[activityName].actualAssetCount
            });
            employeeHoursTotalData[activityName] = {
              totalAph: parseInt(aph),
              targetAph:0,
              targetCount:0,
              translatedKey:activityTotMap[activityName].translatedKey
            };
            employeeHoursData[activityName] = [];

            Object.keys(employeeActTotalMap[activityName]).forEach(
              (employee) => {
                const employeeNameId =
                  employeeActTotalMap[activityName][employee].employeeNameId;

                const aphE =
                  employeeActTotalMap[activityName][employee].assetCount /
                  employeeActTotalMap[activityName][employee].duration;

                employeeHoursTotalData[activityName] = {
                  ...employeeHoursTotalData[activityName],
                  [employeeNameId]: Number(aphE.toFixed(2)),
                };

                // employeeHoursTotalData[activityName] = []

                // employeeHoursTotalData[activityName].push(
                //   {
                //     totalAph: aphE.toFixed(2),
                //     employeeActTotalMap[activityName][employee].assetCount,
                //     employeeActTotalMap[activityName][employee],
                //   },
                // )

                const aphEmployee =
                  employeeActTotalMap[activityName][employee].assetCount /
                  employeeActTotalMap[activityName][employee].duration;
                  let actId;
                  Object.keys(acivityIds).forEach(actName => {
                   if(convertCamelToNormalCase(actName) == activityName){
                     actId = acivityIds[actName];
                   }     
                 });
                const empTargetAph = actId && actsTargetAph[actId] && actsTargetAph[actId].capacity? actsTargetAph[actId].capacity:0;

                employeeHoursData[activityName].push({
                  activityHours:
                    employeeActTotalMap[activityName][employee].duration,
                  assetCount:
                    employeeActTotalMap[activityName][employee].assetCount,
                  aph: Number(aphEmployee.toFixed(2)),
                  employeeNameId: employeeNameId,
                  targetAph: (parseFloat(empTargetAph)).toFixed(2),
                  translatedKey:activityTotMap[activityName].translatedKey,
                  x: employeeNameId,
                  y: Number(aphEmployee.toFixed(2)),
                  goals: empTargetAph > 0  ? [
                    {
                      name: 'Planned',
                      value: (parseFloat(empTargetAph)).toFixed(2) || 0,
                      strokeWidth: 6,
                      //strokeHeight: 12,
                      strokeColor: '#775DD0'
                    }
                  ] : []
                });
              }
            );

            
          });

          // console.log(
          //   "AAAAAAAAAAAAAAA final plannedHoursData ",
          //   plannedHoursData,
          //   "employeeHoursData ",
          //   employeeHoursData,
          //   "employeeHoursTotalData",
          //   employeeHoursTotalData
          // );

          //setPlannedActivityHoursData(plannedHoursData);
          // setEmployeeActivityHoursData({
          //   employeeHoursData: employeeHoursData,
          //   employeeHoursTotalData: employeeHoursTotalData,
          // });
          // setActivityHoursDataLoading(false);
        })
        .catch((error) => {
          setPlannedActivityHoursData({});
          setEmployeeActivityHoursData({
            employeeHoursData: {},
            employeeHoursTotalData: {},
          });
          setActivityHoursDataLoading(false);
          console.log("getDscDashboardCollection err ", error);
        });

        if(selectedBuilding.length == 1){
        //Capacity Planning details bar function>>>>>>>>
      getCapacityPlanningCollection(weekStartDate , selectedBuilding)
        .then((result) =>{ 
           console.log("capacityResult", result)
           if(result.length > 0) {
            result.forEach(resData => {
              let activityData = resData.activityData ? resData.activityData : {};
              activityData && Object.keys(activityData).length >0 &&
              Object.keys(activityData).forEach(act => {
                    let act_id = Number(act.split('_')[1]);
                    let currentDay = moment().weekday()+1;
                    if(!isNaN(act_id) && activityData[act][`day${currentDay}`] ){
                      let act_name = Object.keys(acivityIds).find(key => acivityIds[key] === act_id) ? 
                      convertCamelToNormalCase(Object.keys(acivityIds).find(key => acivityIds[key] === act_id)) : "";
                      let plannedHoursDataInd = plannedHoursData.findIndex(planData => planData.activityName == act_name);
                      //let targetAph = act_id && actsTargetAph[act_id] && actsTargetAph[act_id].capacity? actsTargetAph[act_id].capacity:0;
                      if(plannedHoursDataInd >= 0){
                        let curActCount = Number(activityData[act][`day${currentDay}`]['activityCount']);
                          if(!isNaN(curActCount) && curActCount>0){
                            plannedHoursData[plannedHoursDataInd].targetCount += curActCount;
                            plannedHoursData[plannedHoursDataInd].goals = [
                              {
                                name: 'Planned',
                                value: plannedHoursData[plannedHoursDataInd].targetCount || 0,
                                strokeWidth: 6,
                                // strokeHeight: 15,
                                strokeColor: '#775DD0',
                              }
                            ]
                            //plannedHoursData[plannedHoursDataInd].targetAph = (parseFloat(targetAph).toFixed(2)).toFixed(2);
                            employeeHoursTotalData[act_name].targetCount += curActCount;
                          } 
                     }
                    }
                  })
            })
           }
           if(plannedHoursData.length > 0){
            plannedHoursData.sort((a,b) => 
            {
              if(activitiesInOrder.indexOf(a.activityName)<0 || activitiesInOrder.indexOf(b.activityName)<0){
                return activitiesInOrder.indexOf(b.activityName) - activitiesInOrder.indexOf(a.activityName);
              } else{
                return activitiesInOrder.indexOf(a.activityName) - activitiesInOrder.indexOf(b.activityName)
              }
            });  
           }
           let sortedEmployeeHoursData = employeeHoursData;
           if(Object.keys(employeeHoursData).length > 0){
            sortedEmployeeHoursData = Object.keys(employeeHoursData).sort((a,b) =>{
              if(activitiesInOrder.indexOf(a)<0 || activitiesInOrder.indexOf(b)<0){
                return activitiesInOrder.indexOf(b) - activitiesInOrder.indexOf(a);
              } else{
                return activitiesInOrder.indexOf(a) - activitiesInOrder.indexOf(b)
              }
            }).reduce(
              (obj, key) => { 
                obj[key] = employeeHoursData[key]; 
                return obj;
              }, 
              {}
            );
           }
           console.log("capacityResult", employeeHoursData)
           setPlannedActivityHoursData(plannedHoursData);
           setEmployeeActivityHoursData({
            employeeHoursData: sortedEmployeeHoursData,
            employeeHoursTotalData: employeeHoursTotalData,
          });
           setActivityHoursDataLoading(false);
        })
        .catch((error) => {
          setPlannedActivityHoursData({});
          setEmployeeActivityHoursData({
            employeeHoursData: {},
            employeeHoursTotalData: {},
          });
          setActivityHoursDataLoading(false);
          console.log("capacityPlanning collection err ", error);
        });
      }else{
        setPlannedActivityHoursData(plannedHoursData);
           setEmployeeActivityHoursData({
            employeeHoursData: employeeHoursData,
            employeeHoursTotalData: employeeHoursTotalData,
          });
           setActivityHoursDataLoading(false);
      }
    } else {
      setPlannedActivityHoursData({});
      setEmployeeActivityHoursData({
        employeeHoursData: {},
        employeeHoursTotalData: {},
      });
      setActivityHoursDataLoading(false);
    }
  };


  useEffect(() => {
    let buildingOptionsArray = [];
    selectedDistrictList.map((district) => {
      if (districtBuildingMap[district]) {
        buildingOptionsArray = buildingOptionsArray.concat(
          districtBuildingMap[district]
        );
      }
    });
    setBuildingOptions(buildingOptionsArray);
  }, [selectedDistrictList, districtBuildingMap]);

  useEffect(() => {
    if (selectedBuilding.length < 1 || !selectedDistrictList) {
      SetIsViewDisabled(true);
    } else {
      SetIsViewDisabled(false);
    }

    setPlannedActivityHoursData({});
    setEmployeeActivityHoursData({
      employeeHoursData: {},
      employeeHoursTotalData: {},
    });
  }, [selectedBuilding, selectedDistrictList, viewType, activityStartDate]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleTileLineView = (event) => {
    setTimeLineAnchorEl(event.currentTarget);
  };
  const handleTimeLineClose = (e) => {
    setTimeLineAnchorEl(null);
  };

  const handleClose = (e) => {
    setAnchorEl(null);
  };

  const navTimeLineView = (e) => {
    console.log("target");
    history.push(WARE_HOUSE_TIMELINE_VIEW);
  };
  // const activityStartDateChange = (date) => {
  //   if(!moment(date).isValid() ||
  //     moment(date).isBefore(moment(new Date()).startOf('week'))
  //     || moment(date).isAfter(moment(new Date()).endOf('week'))){
  //     SetIsViewDisabled(true);
  //     SetStartDateError(true)
  //   }else{
  //     setActivityStartDate(date);
  //     SetIsViewDisabled(false);
  //     SetStartDateError(false)
  //   }

  // };

  const selectMultipleDistricts = (event,newValue) => {
    if (newValue.length !== 0) {
      let distCodeExists = false;
      const selectedDistrictCode = newValue[newValue.length - 1].split("-")[0];
      selectedDistrictList.map((district) => {
        const districtCode = district.split("-")[0];
        if (selectedDistrictCode === districtCode) {
          distCodeExists = true;
        }
      });
      setSelectedDistrictList(newValue);
    } else {
      setSelectedDistrictList(newValue);
    }
  };

  const ClockIn = (
    <CardLayout title={t("pgHome.lblClockedIn")} >
      <LoaderView loading={clockedInReportDataLoading}>
        <ClockedIn2 data={clockedInReportData} />
      </LoaderView>
    </CardLayout>
  ); 
  const EActivity = (
      <LoaderView loading={mealEndLoader} >
      <WorkerLogin setMealEndLoader={setMealEndLoader}/>
      </LoaderView>
  );
  const EmpAct = (
    <CardLayout title={t("other.lblEmployeesActivities")}>
      <EmployeesActivities
        employeesUnderManager={employeesUnderManager}
        employeesUnderManagerLoading={employeesUnderManagerLoading}
      />
    </CardLayout>
  );

  const ActByJobRole = (
    <CardLayout
      // onClickMenu={handleClick}
      title={properCase(t("pgHome.report2"))}
    >
      <LoaderView loading={jobFamilyChartLoading && chartLoading}>
        <ActivityByJobRole jobFamilyChart={jobFamilyChart} chart={chart} />
        <Menu
          id="Menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          {options.map((item, index) => {
            return (
              <ListItem alignItems="center" key={index}>
                {/* <Checkbox
                  edge="start"
                  checked={checked.includes(index)}
                  tabIndex={-1}
                  disableRipple
                  onChange={(e) => handleChecked(e, index)}
                /> */}
                <ListItemText dense primary={`${item.name}`} />
              </ListItem>
            );
          })}
        </Menu>
      </LoaderView>
    </CardLayout>
  );

  const actHrsTitle = (
    <> 
          <Grid container alignItems="center" justify="space-arround" spacing ={5}>
          <Grid item xs="auto">
                <Typography style={{color:"#1B75BC", fontWeight:"bold"}} >
                {t("other.lblTotalCountByActivity")}
                </Typography>
            </Grid>
            {/* <Grid item xs="auto" style={{display:"flex", alignItems:'center', fontSize:'0.875rem', color:'#0D3C61'}}>
                <StopIcon style={{color:"#00a88e", fontSize:'30px'}}/>
                <Typography  > {t("other.lblActual")} </Typography>
            </Grid>
            {selectedBuilding.length === 1 && ( <Grid item xs="auto" style={{display:"flex", alignItems:'center', fontSize:'0.875rem', color:'#0D3C61'}}>
                <StopIcon style={{color:"#B2BEB5", fontSize:'30px'}}/>
              <Typography> {t("other.lblPlannedCount")}</Typography>
              </Grid>)
              } */}
            </Grid>
    </>
  )

  const ActHrsPlnd = (
    <CardLayout

     title={actHrsTitle}>
      <ActivityHoursPlanned
        plannedActivityHoursData={plannedActivityHoursData}
        plannedActivityHoursDataLoading={activityHoursDataLoading}
        districtBuildingMapLoading={districtBuildingMapLoading}
        selectedBuildingLength = {selectedBuilding.length}
      />
    </CardLayout>
  );

  const ActHrsByEmp = (
    <CardLayout
    title={t("other.lblActionPerHourByEmp")}
      onClickMenu={handleTileLineView}
    >
      <ActivityHoursByEmployee
        employeeActivityHoursData={employeeActivityHoursData}
        employeeActivityHoursDataLoading={activityHoursDataLoading}
        districtBuildingMapLoading={districtBuildingMapLoading}
      />
      {/* <Menu
        id="Menu"
        anchorEl={timeLineAnchorEl}
        keepMounted
        open={Boolean(timeLineAnchorEl)}
        onClose={handleTimeLineClose}
      >
        {TimeLineoptions.map((item, index) => {
          return (
            <ListItem
              alignItems="center"
              key={index}
              button
              onClick={(event) => navTimeLineView(event)}
            >
              <ListItemText dense primary={`${item.name}`} />
            </ListItem>
          );
        })}
      </Menu> */}
    </CardLayout>
  );

  const checkDistGroup = (group) => {
     let totalGroupLength = Object.keys(districtBuildingMap).filter(ele =>ele.split("-")[0] === group).length;
     let selectedGroupLength = selectedDistrictList.filter(ele =>ele.split("-")[0] === group).length;
     if(selectedGroupLength>0 && totalGroupLength === selectedGroupLength){
       return true;
     }else{
       return false;
     }
  }

  const onDistGroupClick = (group) =>{
    let totalGroup = Object.keys(districtBuildingMap).filter(ele =>ele.split("-")[0] === group);
    let selectedGroupLength = selectedDistrictList.filter(ele =>ele.split("-")[0] === group).length;
    if(selectedGroupLength>0 && totalGroup.length === selectedGroupLength){
      let filtSelctedDisList = selectedDistrictList.filter(ele =>ele.split("-")[0] !== group)
      setSelectedDistrictList([...filtSelctedDisList])
      setSelectedBuilding([]);
      checkDistGroup(group)
    }else{
      setSelectedDistrictList([...new Set([...selectedDistrictList,...totalGroup])])
      setSelectedBuilding([]);
      checkDistGroup(group)
    }
  }

 const checkBuldingGroup = (group) =>{
  let totalGroupLength =buildingOptions.filter(ele =>ele.split(" ")[0] === group).length;
  let selectedGroupLength = selectedBuilding.filter(ele =>ele.split(" ")[0] === group).length;
  if(selectedGroupLength>0 && totalGroupLength === selectedGroupLength){
    return true;
  }else{
    return false;
  }
 }


 const onBuldGroupClick = (group) =>{
  let totalGroup = buildingOptions.filter(ele =>ele.split(" ")[0] === group);
  let selectedGroupLength = selectedBuilding.filter(ele =>ele.split(" ")[0] === group).length;
  if(selectedGroupLength>0 && totalGroup.length === selectedGroupLength){
    let filtSelctedBuildList = selectedBuilding.filter(ele =>ele.split(" ")[0] !== group)
    setSelectedBuilding([...filtSelctedBuildList])
    checkBuldingGroup(group)
  }else{
    setSelectedBuilding([...new Set([...selectedBuilding,...totalGroup])])
    checkBuldingGroup(group)
  }
}

  const districtBuildingAutocomplete = (
    // <LoaderView loading={districtBuildingMapLoading}>
    <Grid
      container
      direction="row"
      // justifyContent="flex-end"
      spacing={4}
      alignItems="center"
    >
      {/* <Grid item xs={8} sm={6} md={3}>
        <Autocomplete
          id="selection"
          disableClearable
          options={viewOptions}
          defaultValue={viewOptions[0]}
          getOptionLabel={(option) =>
            option
              ? option === "Weekly"
                ? properCase(t("other.lblWeekly"))
                : option
              : "NA"
          }
          // style={{ width: 150 }}
          renderInput={(params) => (
            <TextField
              required={true}
              {...params}
              label={properCase(t("other.tlselectedView"))}
              variant="outlined"
              size="small"
            />
          )}
          onChange={(e, v) => {
            setViewType(v);
          }}
        />
      </Grid>
      {viewType === "Daily" && (
        <Grid item xs={10} sm={6} md={3}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              ampm={false}
              disableBackdropClick
              margin="normal"
              id="date-picker-dialog"
              label={t("pgAddEditPunchSupervisor.lblActStartDate")}
              format="MM/dd/yyyy"
              value={activityStartDate}
              onChange={activityStartDateChange}
              onInputChange={activityStartDateChange}
              minDate={moment(new Date()).startOf("week")}
              maxDate={moment(new Date()).endOf("week")}
              KeyboardButtonProps={{
                "aria-label": "Select Punch Date",
              }}
              invalidDateMessage={t("pgAddEditPunchSupervisor.lblInvalidDate")}
              placeholder="MM/dd/yyyy"
              keyboardIcon={<DateRange fontSize="" />}
              error={StartDateError}
              helperText={
                StartDateError && t("pgAddEditPunchSupervisor.lblInvalidDate")
              }
            />
          </MuiPickersUtilsProvider>
        </Grid>
      )} */}
      <Grid item>
        <FormControl className={classes.formControl}>
          <Autocomplete
            options={Object.keys(districtBuildingMap)}
            multiple
            size="small"
            open={districtDropdownOpen}
            disabled={activityHoursDataLoading}
            onOpen={() => setDistrictDropdownOpen(true)}
            onClose={() => { }}
            onBlur={() => setDistrictDropdownOpen(false)}
            value={selectedDistrictList}
            onChange={(event, newValue) => {
              if (newValue !== null) {
                selectMultipleDistricts(event,newValue);
                setSelectedBuilding([]);
                if (
                  newValue.length === Object.keys(districtBuildingMap).length
                ) {
                  setDistrictDropdownOpen(false);
                }
              } else {
                setSelectedDistrictList([]);
                setSelectedBuilding([]);
                setBuildingOptions([]);
              }
            }}
            style={{ minWidth: 200 }}
            classes={classes}
            ListboxComponent={ListboxComponent}
            disableListWrap
            renderOption={(option,{selected}) => (
              <React.Fragment>
                <Checkbox
                  color={"primary"}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                 <Typography
                  style={{ maxWidth: "100%" }}
                  noWrap={true}
                  color="textPrimary"
                 >
                {option}
                </Typography>
              </React.Fragment>
            )}
            renderTags={(value) => {
              //const numTags = value.length;
              const limitTags = 2;
              const selectedGroupNames = [];
              let filteredValues= value.filter(distGroup => {
                 let curGroupName = distGroup.split('-')[0];
                 if(!selectedGroupNames.includes(curGroupName+"-ALL")){
                   let totalGroupLength = Object.keys(districtBuildingMap).filter(ele =>ele.split("-")[0] === curGroupName).length;
                   let selectedGroupLength = value.filter(ele =>ele.split("-")[0] === curGroupName).length;
                   if(selectedGroupLength>0 && totalGroupLength === selectedGroupLength){
                     selectedGroupNames.push(curGroupName+"-ALL");
                     return false;
                   }else{
                     return true
                   }
                 }else{
                   return false;
                 }
               })
               let renderValues = [...new Set([...selectedGroupNames,...filteredValues])]
              return (
                <>
                <Typography
                  style={{ maxWidth: 120 }}
                  noWrap={true}
                  color="textPrimary"
                 >
                  {renderValues.join(',')}
               </Typography>
                  {renderValues.length > limitTags && ` +${renderValues.length-limitTags}`}
                </>
              );
            }}
            groupBy={(option) => option.split('-')[0]}
            renderGroup = {(params) => [
              <ListSubheader onClick={() => onDistGroupClick(params.group)} className={classes.listSubHeader} key={params.key} component="div">
                  <Checkbox
                  key={params.group}
                   checked={checkDistGroup(params.group)}
                   color={"primary"}
                   //onChange={() => onGroupClick(params.group)}
                />
                {params.group + "-ALL"}
              </ListSubheader>,
              params.children,
            ]}
            renderInput={(params) => {
              if (selectedDistrictList.length ===0) {
                return (
                  <TextField
                    {...params}
                    label={t("general.select1")}
                    size="small"
                  />
                );
              } else {
                return (
                  <TextField
                    {...params}
                    label={t("other.lblDashboardDistrict")}
                    // label={t("pgPunch.lblDistrict")}
                    size="small"
                  />
                );
              }
            }}
          />
        </FormControl>
      </Grid>
      <Grid item>
        <FormControl className={classes.formControl}>
          <Autocomplete
            options={
              !isEmptyObject(buildingOptions)
                ? ["Select All"].concat(buildingOptions)
                : buildingOptions
            }
            multiple
            size="small"
            open={buildingDropdownOpen}
            disabled={activityHoursDataLoading}
            onOpen={() => setBuildingDropdownOpen(true)}
            onClose={() => { }}
            onBlur={() => setBuildingDropdownOpen(false)}
            onChange={(event, newValue) => {
              if (newValue !== null) {
                console.log("BUILDING SELECT ", newValue);
                if (newValue[newValue.length - 1] === "Select All") {
                  if(selectedBuilding.length === buildingOptions.length){
                    setSelectedBuilding([]);
                  }else{
                  setSelectedBuilding(buildingOptions);
                  }
                  //setBuildingDropdownOpen(false);
                } else {
                  if(newValue.length === 1){
                    let selectedDistrict = selectedDistrictList.filter(dist =>
                      districtBuildingMap &&  districtBuildingMap[dist] &&  
                      (Array.isArray(districtBuildingMap[dist]) || typeof districtBuildingMap[dist] == "string") &&
                       districtBuildingMap[dist].includes(newValue[0]));  
                       setSelectedAphDistrict(selectedDistrict);
                  }else{
                    setSelectedAphDistrict([]);
                  }     
                  setSelectedBuilding(newValue);
                  if (newValue.length === buildingOptions.length) {
                    setBuildingDropdownOpen(false);
                  }
                }
              } else {
                setSelectedBuilding([]);
              }
            }}
            // onInputChange={(event, newValue) => {
            //   if (!newValue) {
            //     setSelectedBuilding([]);
            //   }
            // }}
            value={selectedBuilding}
            style={{ minWidth: 200 }}
            classes={classes}
            ListboxComponent={ListboxComponent}
            disableListWrap
            groupBy={(option) => option!== "Select All"? option.split(' ')[0]:''}
            renderOption={(option,{selected})=>(
              <>
              <Checkbox
              checked={option!== "Select All" ? selected : buildingOptions.length === selectedBuilding.length}
              key={option}
              color={"primary"}
              />
              {option}
              </>
            )}
            renderTags={(value) => {
              const limitTags = 2;
                const selectedGroupNames = [];
                let filteredValues= value.filter(buildGroup => {
                  let curGroupName = buildGroup.split(' ')[0];
                  if(!selectedGroupNames.includes(curGroupName+"-ALL")){
                    let totalGroupLength = buildingOptions.filter(ele =>ele.split(" ")[0] === curGroupName).length;
                    let selectedGroupLength = value.filter(ele =>ele.split(" ")[0] === curGroupName).length;
                    if(selectedGroupLength>0 && totalGroupLength === selectedGroupLength){
                      selectedGroupNames.push(curGroupName+"-ALL");
                      return false;
                    }else{
                      return true
                    }
                  }else{
                    return false;
                  }
                })
                let renderValues = [...new Set([...selectedGroupNames,...filteredValues])]
              return (
                <>
                  <Typography
                  style={{ maxWidth: 100 }}
                  noWrap={true}
                  color="textPrimary"
                 >
                  {buildingOptions.length === selectedBuilding.length ? "ALL":renderValues.join(',')}
               </Typography>
      
                  {buildingOptions.length !== selectedBuilding.length && renderValues.length > limitTags && ` +${renderValues.length - limitTags}`}
                </>
              );
            }}
            renderGroup = {(params) => params.group.length>0 ? 
              [     
              <ListSubheader onClick={() => {onBuldGroupClick(params.group)}}  className={classes.listSubHeader} key={params.key} component="div">
                  <Checkbox
                  key={params.group}
                   checked={checkBuldingGroup(params.group)}
                   color={"primary"}
                />
                {params.group + "-ALL"}
              </ListSubheader>,
              params.children,
            ]:[params.children]}
            renderInput={(params) => {
              if (selectedBuilding.length < 1) {
                return (
                  <TextField
                    {...params}
                    label={t("general.select2")}
                    size="small"
                  />
                );
              } else {
                return <TextField {...params} label={t("other.lblDashOnlyBuilding")} size="small" />;
              }
            }}
          />
        </FormControl>
      </Grid>
     <Grid md={2} style={{paddingTop: '20px', textAlign: 'right'}} >
        <formControl className={classes.formControl}>
          <TextField
                value={currentDate}
                InputProps={{ disableUnderline: true }}
                size="small"
              />
        </formControl>      
      </Grid>
     <Grid item>
        <Button
          color="primary"
          variant="outlined"
          disabled={isViewDisabled}
          // className={classes.button}
          onClick={(e)=>handleView()}
        >
        {t("other.lblView")}
        </Button>
      </Grid>
    </Grid>
    // </LoaderView>
  );

  const manageForOptions = () => {
    switch (imtRole) {
      case "Admin":
        return allApprovers;
        break;
      case "Super User":
        return loggedinPlusDelegate;
        break;
      case "Supervisor":
        return newOptions;
        break;
      default:
        return newOptions;
    }
  }

  const managerAutocomplete = (
    <Autocomplete
      options={manageForOptions()}
      getOptionLabel={(option) =>
        option && option.managerFirstName
          ? `${option.managerFirstName} ${option.managerLastName} (${option.managerId})`
          : ""
      }
      style={{ width: 200, margin: 7 }}
      value={selectedManager}
      onChange={(event, newValue) => {
        if (newValue !== null) {
          if(prevSelectedManager.managerCountry!== newValue.managerCountry){
            setDistrictBuildingMapLoading(true);
            setDistrictBuildingMap({});
            setSelectedDistrictList([]);
            setSelectedBuilding([]);
            setPlannedActivityHoursData({});
            setEmployeeActivityHoursData({
              employeeHoursData: {},
              employeeHoursTotalData: {},
            });
            getDistrictBuildingMapForIMWarehouse(newValue.managerCountry)
              .then((data) => {
                setDistrictBuildingMap(data);
                setDistrictBuildingMapLoading(false);
                setActivityHoursDataLoading(false);
              })
              .catch((error) => {
                setDistrictBuildingMapLoading(false);
                console.log("getDistrictBuildingMapForIMWarehouse err ", error);
              });
          }else{
            setPlannedActivityHoursData({});
            setEmployeeActivityHoursData({
              employeeHoursData: {},
              employeeHoursTotalData: {},
            });
            if(selectedBuilding.length>0){
              handleView(newValue);
            }
          }
          setPrevSelectedManager(newValue);
          setSelectedManager(newValue);
        } else {
          setSelectedManager({});
        }
      }}
      renderInput={(params) => {
        if (isEmptyObject(selectedManager)) {
          return <TextField {...params}  label={properCase(t("other.lblSelectManager"))} />;
        } else {
          return <TextField {...params}      label={properCase(t("other.lblManager"))}/>;
        }
      }}
    />
  );

  return (
    <>
      {/* <Grid container direction="column" spacing={2}> */}
      {/* <Grid container item alignItems="center">
          <Grid item xs={6}>
            {managerAutocomplete}
          </Grid>
          <Grid item xs={6}>
            {districtBuildingAutocomplete}
          </Grid>
        </Grid> */}
        <Grid container item spacing={2} style={{marginTop:10}}>
          <Grid container spacing={2} direction="column" xs={12} sm={12} md={6} lg={6} xl={6} item>
            <Grid item style={{paddingBottom:0,paddingTop:0}}></Grid>
          </Grid>
          <Grid container spacing={2} direction="column" xs={12} sm={12} md={6} lg={6} xl={6} item>
          <Grid item style={{paddingBottom:0,paddingTop:0}}>
          <Typography style={{marginLeft :5, color:"#1B75BC", fontWeight:"bold"}} >
              {t("other.lbleOpsLogViewSkp")}
          </Typography>
        </Grid>
            
          </Grid>
      </Grid>
      <Grid container item spacing={2}>
        <Grid container spacing={2} direction="column" xs={12} sm={12} md={6} lg={6} xl={6} item style={{paddingTop:0, marginTop:0}}>
          <Grid item>{managerAutocomplete}</Grid>
          <Grid item>{ClockIn}</Grid>
          <Grid item>{EActivity}</Grid>
          <Grid item>{ActByJobRole}</Grid>
          <Grid item>{EmpAct}</Grid>
        </Grid>
        <Grid container spacing={2} direction="column" xs={12} sm={12} md={6} lg={6} xl={6} item style={{paddingTop:0, marginTop:0}}>
         
          <Grid item>{districtBuildingAutocomplete}</Grid>
          <Grid item>{ActHrsPlnd}</Grid>
          <Grid item>{ActHrsByEmp}</Grid>
        </Grid>
      </Grid>
      {/* </Grid> */}
    </>
  );
};

ListboxComponent.propTypes = {
  children: PropTypes.node,
};

export default HomeView;
